import styled from "styled-components";

export const EditWrapper = styled.div`
  margin-top: 18px;
  width: calc(100% - 40px);
  height: 764px;
  padding: 20px;
  border-radius: 20px;
  border: 0.707px solid #d9d9d9;
  background: #fff;
  box-shadow: 0 2.829px 2.829px 0 rgba(0, 0, 0, 0.25);

  display: flex;
  flex-direction: column;
`;

export const EditTabHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .list {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
  }
`;

export const EditIsHideLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  color: #1a191a;
  font-family: Pretendard;
  font-size: 20.233px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  > .label {
    width: 98px;
  }
`;

export const EditTabHeaderItem = styled.div<{ selected: boolean }>`
  padding: 8px 12px;
  border-radius: 15px;
  background: ${(props) => (props.selected ? "#6436E7" : "#fff")};
  border: 1px solid ${(props) => (props.selected ? "#6436E7" : "#B7B7B7")};
  color: ${(props) => (props.selected ? "#fff" : "#202020")};
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;

  &:hover {
    background: ${(props) => (props.selected ? "#6436E7" : "#F0F0F0")};
  }
`;

export const EditLine = styled.div`
  margin-top: 20px;
  width: 100%;
  height: 2px;
  background: #d9d9d9;
`;
